<main class="main">
    <app-layout [user]="user" [userID]="userID" [userImage]="userImage" [userName]="userName" [userRole]="userRole" [logged]="logged"></app-layout>
    <app-toast></app-toast>
</main>
